module.exports = __webpack_public_path__ + "img/forest.6c568d34.png";